import { render, staticRenderFns } from "./CustomLabelMandatory.vue?vue&type=template&id=7315d2a4&scoped=true&"
import script from "./CustomLabelMandatory.vue?vue&type=script&lang=js&"
export * from "./CustomLabelMandatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315d2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7315d2a4')) {
      api.createRecord('7315d2a4', component.options)
    } else {
      api.reload('7315d2a4', component.options)
    }
    module.hot.accept("./CustomLabelMandatory.vue?vue&type=template&id=7315d2a4&scoped=true&", function () {
      api.rerender('7315d2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/job-request/components/CustomLabelMandatory.vue"
export default component.exports